import { render, staticRenderFns } from "./AssetsConfig.vue?vue&type=template&id=5396c89a&scoped=true"
import script from "./AssetsConfig.vue?vue&type=script&lang=js"
export * from "./AssetsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5396c89a",
  null
  
)

export default component.exports